import AppointmentInt from "./AppointmentInt";
import { Contacts } from "../Contacts/Contacts";

export const AppointmentDates: AppointmentInt[] = [
  // Examples
  // {
  //   startdate: "08.06.2025",
  //   starttime: "09:00",
  //   endtime: "08.06.2025",
  //   enddate: "18:30",
  //   what: "Gildefest",
  //   ...Contacts.Wangels
  //   // id: "Wnagle".concat((Math.random() + 1).toString(36).substring(7)),
  //   // who: "Schweinegilde Wangels von 1935 e.V.",
  //   // street: "Alte Landstr. 18",
  //   // plz: "23758",
  //   // town: "Wangels",
  //   // location: "Gilde",
  //   // telefon: "",
  //   // email: "",
  // },
  // {
  //   startdate: "17.05.2025",
  //   starttime: "09:00",
  //   endtime: "",
  //   enddate: "",
  //   what: "Arbeitseinsatz am Gildehaus",
  //   ...Contacts.Blekendorf,
  // },
  // {
  //   startdate: "2025",
  //   starttime: "",
  //   enddate: "",
  //   endtime: "",
  //   what: "48. Öllermanntreffen der Ostholsteiner Gilden in Preetz",
  //   ...Contacts.Preetz,
  // },
  // {
  //   startdate: "02.07.2025",
  //   starttime: "",
  //   enddate: "06.07.2025",
  //   endtime: "",
  //   what: "750 Jahrfeier Lütjenburg",
  //   id: "Ltj".concat((Math.random() + 1).toString(36).substring(7)),
  //   who: "Stadt Lütjenburg",
  //   street: "",
  //   plz: "24321",
  //   town: "Lütjenburg",
  //   location: "ganze Stadt",
  //   telefon: "04381/4020-22",
  //   email: "",
  // },
  // {
  //   startdate: "26.08.2026",
  //   starttime: "19:30",
  //   endtime: "21:30",
  //   enddate: "26.08.2026",
  //   what: "Vorstandssitzung verschoben vom 02.09.2026 auf 26.08.2026",
  //   highlight: true,
  //   ...Contacts.Blekendorf,
  // },
  //

  // 2026

  // einzeltermine
  {
    startdate: "18.01.2026",
    starttime: "10:00",
    endtime: "",
    enddate: "",
    what: "Neujahrsfrühstück",
    ...Contacts.Blekendorf,
  },
  {
    startdate: "20.03.2026",
    starttime: "19:30",
    endtime: "",
    enddate: "",
    what: "Jahreshauptversammlung",
    ...Contacts.Blekendorf,
  },
  {
    startdate: "19.04.2026",
    starttime: "10:00",
    endtime: "17:00",
    enddate: "19.04.2026",
    what: "Pokalschießen für Vereine und Verbände",
    ...Contacts.Blekendorf,
  },
  {
    startdate: "26.04.2026",
    starttime: "10:00",
    endtime: "17:00",
    enddate: "26.04.2026",
    what: "Pokalschießen",
    ...Contacts.Matzwitz,
  },
  {
    startdate: "16.05.2026",
    starttime: "",
    endtime: "",
    enddate: "",
    what: "Gildefest",
    ...Contacts.Neuhaus,
  },
  {
    startdate: "26.05.2026",
    starttime: "",
    endtime: "",
    enddate: "",
    what: "Gildefest",
    ...Contacts.Luetjenburg,
  },
  {
    startdate: "30.05.2026",
    starttime: "",
    endtime: "",
    enddate: "",
    what: "Gildefest",
    ...Contacts.Hoegsdorf,
  },
  {
    startdate: "30.05.2026",
    starttime: "",
    endtime: "",
    enddate: "",
    what: "Gildefest",
    ...Contacts.Darry,
  },
  {
    startdate: "08.11.2026",
    starttime: "",
    endtime: "",
    enddate: "",
    what: "Pokalschießen",
    ...Contacts.Darry,
  },
  {
    startdate: "31.05.2026",
    starttime: "",
    endtime: "",
    enddate: "",
    what: "Pokalschießen",
    ...Contacts.Hassberg,
  },
  {
    startdate: "05.06.2026",
    starttime: "",
    endtime: "",
    enddate: "",
    what: "Gildefest",
    ...Contacts.Hassberg,
  },
  {
    startdate: "06.06.2026",
    starttime: "",
    endtime: "",
    enddate: "",
    what: "Gildefest",
    ...Contacts.Wentorf,
  },
  {
    startdate: "06.06.2026",
    starttime: "",
    endtime: "",
    enddate: "",
    what: "Gildefest",
    ...Contacts.Behrensdorf,
  },
  {
    startdate: "13.06.2026",
    starttime: "",
    endtime: "",
    enddate: "",
    what: "Gildefest",
    ...Contacts.Dannau,
  },
  {
    startdate: "20.06.2026",
    starttime: "",
    endtime: "",
    enddate: "",
    what: "Gildefest",
    ...Contacts.RathlauGildefest,
  },
  {
    startdate: "05.06.2026",
    starttime: "16:30",
    endtime: "",
    enddate: "",
    what: "Aufbau für unser Gildefest",
    ...Contacts.Blekendorf,
  },
  {
    startdate: "06.06.2026",
    starttime: "08:00",
    endtime: "",
    enddate: "",
    what: "Gildefest",
    ...Contacts.Blekendorf,
  },
  {
    startdate: "13.06.2026",
    starttime: "",
    endtime: "",
    enddate: "",
    what: "Gildefest",
    ...Contacts.Kakoehl,
  },
  {
    startdate: "27.06.2026",
    starttime: "",
    endtime: "",
    enddate: "",
    what: "Gildefest",
    ...Contacts.Matzwitz,
  },
  {
    startdate: "16.08.2026",
    starttime: "",
    endtime: "",
    enddate: "",
    what: "Pokalschießen",
    ...Contacts.Neuhaus,
  },
  {
    startdate: "13.09.2026",
    starttime: "",
    endtime: "",
    enddate: "",
    what: "Pokalschießen",
    ...Contacts.Rathlau,
  },
  {
    startdate: "20.09.2026",
    starttime: "",
    endtime: "",
    enddate: "",
    what: "Pokalschießen",
    ...Contacts.Blekendorf,
  },
  {
    startdate: "27.09.2026",
    starttime: "",
    endtime: "",
    enddate: "",
    what: "Pokalschießen",
    ...Contacts.Kakoehl,
  },
  {
    startdate: "10.10.2026",
    starttime: "19:00",
    endtime: "",
    enddate: "",
    what: "Drei-Gilden-Ball",
    ...Contacts.DreiGildenBall,
  },
  {
    startdate: "2025",
    starttime: "",
    enddate: "2025",
    endtime: "",
    what: "Ältermanntreffen in Dannau",
    ...Contacts.Dannau,
  },
  {
    startdate: "22.03.2026",
    starttime: "10:00",
    endtime: "13:00",
    enddate: "22.03.2026",
    what: "Preisschießen für Jedermann",
    ...Contacts.Blekendorf,
  },
  {
    startdate: "24.01.2026",
    starttime: "19:00",
    endtime: "",
    enddate: "",
    what: "Spieleabend: Skat und Kniffel",
    ...Contacts.Blekendorf,
  },
  {
    startdate: "01.02.2026",
    starttime: "10:00",
    endtime: "01.02.2026",
    enddate: "17:00",
    what: "Pokalschießen für Vereine, Firmen & Verbände",
    ...Contacts.Kakoehl,
  },
  {
    startdate: "18.01.2026",
    starttime: "10:00",
    endtime: "18.01.2026",
    enddate: "17:00",
    what: "Pokal- und Preisschießen",
    ...Contacts.Hoegsdorf,
  },
  // Vorstandssitzung
  {
    startdate: "07.01.2026",
    starttime: "19:30",
    endtime: "21:30",
    enddate: "07.01.2026",
    what: "Vorstandssitzung",
    ...Contacts.Blekendorf,
  },
  {
    startdate: "04.02.2026",
    starttime: "19:30",
    endtime: "21:30",
    enddate: "04.02.2026",
    what: "Vorstandssitzung",
    ...Contacts.Blekendorf,
  },
  {
    startdate: "04.03.2026",
    starttime: "19:30",
    endtime: "21:30",
    enddate: "04.03.2026",
    what: "Vorstandssitzung",
    ...Contacts.Blekendorf,
  },
  {
    startdate: "01.04.2026",
    starttime: "19:30",
    endtime: "21:30",
    enddate: "01.04.2026",
    what: "Vorstandssitzung",
    ...Contacts.Blekendorf,
  },
  {
    startdate: "06.05.2026",
    starttime: "19:30",
    endtime: "21:30",
    enddate: "06.05.2026",
    what: "Vorstandssitzung",
    ...Contacts.Blekendorf,
  },
  {
    startdate: "03.06.2026",
    starttime: "19:30",
    endtime: "21:30",
    enddate: "03.06.2026",
    what: "Vorstandssitzung",
    ...Contacts.Blekendorf,
  },
  {
    startdate: "01.07.2026",
    starttime: "19:30",
    endtime: "21:30",
    enddate: "01.07.2026",
    what: "Vorstandssitzung",
    ...Contacts.Blekendorf,
  },
  {
    startdate: "05.08.2026",
    starttime: "19:30",
    endtime: "21:30",
    enddate: "05.08.2026",
    what: "Vorstandssitzung",
    ...Contacts.Blekendorf,
  },
  {
    startdate: "26.08.2026",
    starttime: "19:30",
    endtime: "21:30",
    enddate: "26.08.2026",
    what: "Vorstandssitzung verschoben vom 02.09.2026 auf 26.08.2026",
    highlight: true,
    ...Contacts.Blekendorf,
  },
  {
    startdate: "07.10.2026",
    starttime: "19:30",
    endtime: "21:30",
    enddate: "07.10.2026",
    what: "Vorstandssitzung",
    ...Contacts.Blekendorf,
  },
  {
    startdate: "04.11.2026",
    starttime: "19:30",
    endtime: "21:30",
    enddate: "04.11.2026",
    what: "Vorstandssitzung",
    ...Contacts.Blekendorf,
  },
  {
    startdate: "02.12.2026",
    starttime: "19:30",
    endtime: "21:30",
    enddate: "02.12.2026",
    what: "Vorstandssitzung",
    ...Contacts.Blekendorf,
  },
  {
    startdate: "24.01.2026",
    starttime: "09:30",
    endtime: "",
    enddate: "",
    what: "Arbeitseinsatz am Gildehaus",
    ...Contacts.Blekendorf,
  },
  // uebungsschiessen
  {
    startdate: "01.01.2026",
    starttime: "19:00",
    endtime: "21:00",
    enddate: "01.01.2026",
    what: "Übungsschießen",
    ...Contacts.Blekendorf,
  },
  {
    startdate: "05.02.2026",
    starttime: "19:00",
    endtime: "21:00",
    enddate: "05.02.2026",
    what: "Übungsschießen",
    ...Contacts.Blekendorf,
  },
  {
    startdate: "05.03.2026",
    starttime: "19:00",
    endtime: "21:00",
    enddate: "05.03.2026",
    what: "Übungsschießen",
    ...Contacts.Blekendorf,
  },
  {
    startdate: "09.04.2026",
    starttime: "19:00",
    endtime: "21:00",
    enddate: "09.04.2026",
    what: "Übungsschießen",
    ...Contacts.Blekendorf,
  },
  {
    startdate: "07.05.2026",
    starttime: "19:00",
    endtime: "21:00",
    enddate: "07.05.2026",
    what: "Übungsschießen",
    ...Contacts.Blekendorf,
  },
  {
    startdate: "04.06.2026",
    starttime: "19:00",
    endtime: "21:00",
    enddate: "04.06.2026",
    what: "Übungsschießen fällt aus wegen Gildefestaufbau",
    highlight: true,
    ...Contacts.Blekendorf,
  },
  {
    startdate: "02.07.2026",
    starttime: "",
    endtime: "",
    enddate: "02.07.2026",
    what: "Übungsschießen verschoben auf 09. Juli!",
    highlight: true,
    ...Contacts.Blekendorf,
  },
  {
    startdate: "09.07.2026",
    starttime: "19:00",
    endtime: "21:00",
    enddate: "09.07.2026",
    what: "Übungsschießen Nachholtermin vom 02. Juli",
    highlight: true,
    ...Contacts.Blekendorf,
  },
  {
    startdate: "06.08.2026",
    starttime: "19:00",
    endtime: "21:00",
    enddate: "06.08.2026",
    what: "Übungsschießen",
    ...Contacts.Blekendorf,
  },
  {
    startdate: "03.09.2026",
    starttime: "19:00",
    endtime: "21:00",
    enddate: "03.09.2026",
    what: "Übungsschießen",
    ...Contacts.Blekendorf,
  },
  {
    startdate: "01.10.2026",
    starttime: "19:00",
    endtime: "21:00",
    enddate: "01.10.2026",
    what: "Übungsschießen",
    ...Contacts.Blekendorf,
  },
  {
    startdate: "05.11.2026",
    starttime: "19:00",
    endtime: "21:00",
    enddate: "05.11.2026",
    what: "Übungsschießen",
    ...Contacts.Blekendorf,
  },
  {
    startdate: "03.12.2026",
    starttime: "19:00",
    endtime: "21:00",
    enddate: "03.12.2026",
    what: "Übungsschießen",
    ...Contacts.Blekendorf,
  },
];
